import { useEffect } from 'react'
import { useElara } from './useElara'
import type { UIAction } from '../types'

/**
 * Registers UI actions on mount and unregisters on unmount.
 * Components use this to declare what actions they expose to ELARA.
 */
export function useElaraActions(actions: UIAction[]): void {
    const elara = useElara()
    // Use the stable callbacks directly rather than the whole context object.
    // contextValue changes whenever availableActions changes (after registerActions),
    // which would make `elara` a new reference every render and create an infinite loop.
    const registerActions = elara?.registerActions
    const unregisterActions = elara?.unregisterActions

    useEffect(() => {
        if (!registerActions || !unregisterActions || actions.length === 0) return

        registerActions(actions)

        return () => {
            unregisterActions(actions.map((a) => a.actionId))
        }
    }, [registerActions, unregisterActions, actions])
}
